import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { ColumnType, TableHeader } from '../../components/Table'
import { useTableColumnVisibility } from '../../redux/table/hooks'
import { OrdersActions, getTransactionFilters } from '../../redux/orders'
import { createTFunction } from '../../utils/helpers'
import { OrderData } from '../../redux/order'

export type TransactionsDataTableHeaderProps = {
  tableColumns: ColumnType<OrderData>[]
}

export const TransactionsDataTableHeader = ({ tableColumns }: TransactionsDataTableHeaderProps) => {
  const { t } = useTranslation(['form', 'account'])
  const tt = createTFunction('account:Transactions.', t)
  const dispatch = useDispatch()

  const columnSelection = useTableColumnVisibility('transactions')
  const filters = useSelector(getTransactionFilters)

  return (
    <TableHeader
      advancedFilterDialog="TransactionsAdvancedFilter"
      columnSelectorProps={{ columns: tableColumns, ...columnSelection }}
      isAdvancedFilterActive={_.some(_.keys(filters))}
      onSearchSubmit={values => dispatch(OrdersActions.setSearchFilter(values.query))}
      searchLabel={t('form:Search')}
      searchName="query"
      searchPlaceholder={tt('InsertOrderId')}
    />
  )
}
